import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { FormElementType, FormsState } from './types';

const getState = (state: State): FormsState => state.content.forms;

const getForms = (state: State): FormsState | Record<string, any> => getState(state) || {};

const getFormElementsById = (
  state: State,
  formId: string,
): RemoteRecord<FormElementType[]> => new RemoteRecord(getForms(state).elements[formId]);

const getFormSubmissionById = (
  state: State,
  formId: string,
): RemoteRecord<FormElementType[]> => new RemoteRecord(getForms(state).submit[formId]);

export {
  getFormElementsById,
  getForms,
  getFormSubmissionById,
  getState,
};
